export default __webpack_public_path__ + "static/media/ChessBoard.39c1da26.png";